import { PositionConfig } from "slotworks/config/asset-config-schema";
import ButtonElement from "slotworks/graphics/elements/button-element";
import GraphicsManager from "slotworks/graphics/graphics-manager";
import Layers from "slotworks/graphics/layers/layers";

export function generateButton(id: string, config: PositionConfig, layer: Layers) {
    const idParts = id.split("-");
    const buttonId = idParts[0];
    const buttonState = idParts.length > 1 ? idParts[1] : "up";

    let button = layer.getButton(buttonId);

    if (!button) {
        const container = new PIXI.Container();
        container.name = "btn-" + buttonId;
        container.x = config.x;
        container.y = config.y;
        layer.container.addChildAt(container, 0);
        button = new ButtonElement(container);
        layer.addButton(buttonId, button);
    }

    const sprite = GraphicsManager.createSprite(config.id);

    sprite.x = config.x - button.container.x;
    sprite.y = config.y - button.container.y;
    sprite.width = config.width;
    sprite.height = config.height;

    if (buttonState === "hit") {
        button.setHitArea(sprite);
    } else {
        button.addState(buttonState, sprite);
    }
    sprite.name = id;
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/graphics/layers/populators/generate-button.ts